import { buildPolicyHook, useCurrentUserDataLifecycle } from 'policy-lib';
import { EnrichmentPolicy } from './EnrichmentPolicy';
import { useEnrichmentSettings } from '../EnrichmentSettingsProvider';
const useBaseEnrichmentPolicy = buildPolicyHook(EnrichmentPolicy);

/**
 * Get access to the enrichment policy tied to the current user.
 *
 * @returns {object} {policy: EnrichmentPolicy, refresh, isLoading, isRefreshing}
 * - `policy`: The current enrichment policy.
 * - `refresh`: A function to refresh the policy.
 * - `isLoading`: A boolean indicating if the policy is loading.
 * - `isRefreshing`: A boolean indicating if the policy is refreshing.
 */
export function useEnrichmentPolicy() {
  const {
    settings,
    isLoaded
  } = useEnrichmentSettings();
  const {
    isRefreshing,
    refresh
  } = useCurrentUserDataLifecycle();
  const policy = useBaseEnrichmentPolicy({
    settings,
    isLoaded
  });
  return {
    isLoading: !policy.isLoaded,
    isRefreshing,
    policy,
    refresh
  };
}